import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';
import {LoginComponent} from './appcomponents/Login/login.component';
import {ClaimComponent} from './appcomponents/claim';
import {Anonguard} from './gaurds/anonguard';
import {Authguard} from './gaurds/authguard';
import {Login2Component} from './appcomponents/login2.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent, canActivate: [Authguard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent, canActivate: [Anonguard]
  },
  {
    path: 'login2',
    component: Login2Component, canActivate: [Anonguard]
  },
  {
    path: 'claim',
    component: ClaimComponent, canActivate: [Authguard]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/app.routing.ts